import { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { Language } from '../Localized';

export const enum FormFieldViolationScope {
    FIELD = 'FIELD',
    GLOBAL = 'GLOBAL',
}

interface FormFieldViolationEntry {
    fieldName: string;
    type: 'LENGTH';
    scope: FormFieldViolationScope.FIELD;
    humanReadableMessage: {
        byLanguage: { [key in Language]: string };
    };
    max?: number;
    min?: number;
    message: string;
}

export interface FormGlobalViolationEntry {
    issue: {
        humanReadableMessage: {
            byLanguage: { [key in Language]: string };
        };
        message: string;
    };
    scope: FormFieldViolationScope.GLOBAL;
}

export function isFormGlobalViolationEntry(
    err: FormViolationEntry | undefined,
): err is FormGlobalViolationEntry {
    return err?.scope === FormFieldViolationScope.GLOBAL;
}

export function isFieldGlobalViolationEntry(
    err: FormViolationEntry | undefined,
): err is FormFieldViolationEntry {
    return err?.scope === FormFieldViolationScope.FIELD;
}

// This should ideally be properly typed…
export interface ValidationData {
    violations: FormViolationEntry[];
}

export type FormViolationEntry =
    | FormGlobalViolationEntry
    | FormFieldViolationEntry;

export function addValidationErrorsToForm<TFieldValues extends FieldValues>(
    errorData: ValidationData,
    setError: UseFormSetError<TFieldValues>,
    language: Language,
): FormGlobalViolationEntry[] {
    const globalErrors: FormGlobalViolationEntry[] = [];

    errorData.violations.forEach(report => {
        if (report.scope === FormFieldViolationScope.GLOBAL) {
            globalErrors.push(report);
        } else {
            setError(report.fieldName as Path<TFieldValues>, {
                message: report.humanReadableMessage.byLanguage[language],
                type: report.type ?? 'validation',
            });
        }
    });

    return globalErrors;
}
